module.exports = __webpack_public_path__ + "img/icon-27.177800f7.png";